import APP_ROUTER from 'constants/router'
import IntlMessages from 'helpers/IntlMessages'
import SystemMessages from 'helpers/SystemMessages'
import { toArrayOptions } from 'helpers/utils'

export const RESPONSE_STATUS_CODE = {
  UNAUTHORIZE: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404
}

export const STORAGE_KEYS = {
  accessToken: '@accessToken',
  refreshToken: '@refreshToken',
  interfaceLabel: '@interfaceLabelBackoffice'
}

export const SPECIAL_ROUTES = [
  APP_ROUTER.login,
  APP_ROUTER.unauthorized,
  APP_ROUTER.dashboard,
  APP_ROUTER.simulatorVehicleAPIs,
  APP_ROUTER.privacyPolicy,
  APP_ROUTER.notificationSimulator,
  APP_ROUTER.configNotificationSystem,
  APP_ROUTER.rolesConfiguration,
  APP_ROUTER.businessSettings,
  APP_ROUTER.odooSettings,
  APP_ROUTER.generalSettings,
  APP_ROUTER.regionalSettings,
  APP_ROUTER.documentation,
  APP_ROUTER.alertConfigurations,
  APP_ROUTER.connectivity
]

export const SECTION_KEYS = {
  CixiCenterContent: 'cixicenter_content'
}

export const DEFAULT_LANGUAGE_ISO_CODE = 'eng'

export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{10,}/

export const DATE_FORMAT = {
  NONE: 'none',
  SHORT: 'dateFormatShort',
  MEDIUM: 'dateFormatMedium',
  LONG: 'dateFormatLong',
  TO_SERVER: 'dateFormatToServer',
  TIME_LONG: 'timeFormatLong',
  SHORT_BY_DASH: 'dateFormatShortByDash'
}

export const LONG_DATE_OPTIONS = { formatType: DATE_FORMAT.LONG }

export const DATE_PICKER_FORMAT = {
  short: 'MM/dd/yyyy',
  shortByDash: 'yyyy-MM-dd'
}

export const PAGINATION = {
  offset: 0,
  firstPage: 1,
  limit: 30,
  unlimited: 0,
  maximumLimit: 1000
}

export const LEFT_TO_RIGHT = 'left to right'

export const RIGHT_TO_LEFT = 'right to left'

export const DEFAULT_LANGUAGE = 'English'

export const LOGIN_ERROR_MESSAGE = {
  err_user_not_found: <SystemMessages id="login.err_user_not_found" />,
  err_email_or_password_incorrect: (
    <SystemMessages id="login.err_email_or_password_incorrect" />
  ),
  err_invalid_account: <SystemMessages id="login.err_invalid_account" />
}

export const MESSAGE_VALIDATION_PASSWORD = {
  schema: <SystemMessages id="password.incorrect" />,
  match: <SystemMessages id="password.not_match" />,
  newPassRequired: <SystemMessages id="password.new_pass_required" />,
  confirmPassRequired: <SystemMessages id="password.confirm_pass_required" />
}

export const SAVE_SUCCESS_MESSAGE = <SystemMessages id="save_success_message" />

export const SAVE_FAILED_MESSAGE = <SystemMessages id="save_failed_message" />

export const CREATE_SUCCESS_MESSAGE = (
  <SystemMessages id="create_success_message" />
)

export const CREATE_FAILED_MESSAGE = (
  <SystemMessages id="create_failed_message" />
)

export const CREATE_TRANSLATION_SUCCESS_MESSAGE = (
  <SystemMessages id="create_translation_success_message" />
)

export const CREATE_TRANSLATION_FAILED_MESSAGE = (
  <SystemMessages id="create_translation_failed_message" />
)

export const UPDATE_SUCCESS_MESSAGE = (
  <SystemMessages id="update_success_message" />
)

export const UPDATE_FAILED_MESSAGE = (
  <SystemMessages id="update_failed_message" />
)

export const UPDATE_TRANSLATION_SUCCESS_MESSAGE = (
  <SystemMessages id="update_translation_success_message" />
)

export const UPDATE_TRANSLATION_FAILED_MESSAGE = (
  <SystemMessages id="update_translation_failed_message" />
)

export const DELETE_SUCCESS_MESSAGE = (
  <SystemMessages id="delete_success_message" />
)

export const DELETE_FAILED_MESSAGE = (
  <SystemMessages id="delete_failed_message" />
)

export const DELETE_TRANSLATION_SUCCESS_MESSAGE = (
  <SystemMessages id="delete_translation_success_message" />
)
export const DELETE_TRANSLATION_FAILED_MESSAGE = (
  <SystemMessages id="delete_translation_failed_message" />
)

export const UPDATE_LABELS_SUCCESS_MESSAGE = (
  <SystemMessages id="update_labels_success_message" />
)

export const UPDATE_LABELS_FAILED_MESSAGE = (
  <SystemMessages id="update_labels_failed_message" />
)

export const UPDATE_MESSAGES_SUCCESS_MESSAGE = (
  <SystemMessages id="update_messages_success_message" />
)

export const UPDATE_MESSAGES_FAILED_MESSAGE = (
  <SystemMessages id="update_messages_failed_message" />
)

export const UPDATE_TEXTS_SUCCESS_MESSAGE = (
  <SystemMessages id="update_texts_success_message" />
)

export const UPDATE_TEXTS_FAILED_MESSAGE = (
  <SystemMessages id="update_texts_failed_message" />
)

export const IMPORT_SUCCESS_MESSAGE = (
  <SystemMessages id="import_success_message" />
)

export const IMPORT_FAILED_MESSAGE = (
  <SystemMessages id="import_failed_message" />
)

export const UPLOAD_SUCCESS_MESSAGE = (
  <SystemMessages id="upload_success_message" />
)

export const UPLOAD_FAILED_MESSAGE = (
  <SystemMessages id="upload_failed_message" />
)

export const PREFIX_BASE64 = ';base64'

export const PREFIX_IMAGE_BASE64 = 'data:image/png;base64'

export const LANGUAGE_LIST = [
  {
    label: 'English',
    value: 'eng',
    nativeName: 'English',
    key: 0,
    flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAABLAQMAAABnbRrWAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABlBMVEX////OESShKa/1AAAAAWJLR0QAiAUdSAAAAAd0SU1FB+YEEw0yASlK+zoAAAAhSURBVDjLY2AAA8b/fxhQwKjAiBD4jwp+jDCB0eQwggUACC5lxyHmcj0AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDQtMTlUMTM6NTA6MDErMDA6MDBmnE1DAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA0LTE5VDEzOjUwOjAxKzAwOjAwF8H1/wAAAABJRU5ErkJggg=='
  },
  {
    label: 'French',
    value: 'fra',
    nativeName: 'French',
    key: 1,
    flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAABTBAMAAABACBVQAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAD1BMVEUAJlRUbYz////eYG7OESZmtw3fAAAAAWJLR0QCZgt8ZAAAAAd0SU1FB+YBFQEdGcyrcskAAAAzSURBVFjD7cshAQAgEASwowpfBEH/TBQ4i9v8kmLtYm5x4vu+7/u+7/u+7/u+7/u+/+k/XcG18y207eUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDEtMjFUMDE6Mjk6MjUrMDA6MDDmiE0oAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTAxLTIxVDAxOjI5OjI1KzAwOjAwl9X1lAAAAABJRU5ErkJggg=='
  },
  {
    label: 'German',
    value: 'deu',
    nativeName: 'German',
    key: 2,
    flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAABLAgMAAAAgzWAGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEUAAADdAAD/zgD///9i/kqcAAAAAWJLR0QDEQxM8gAAAAd0SU1FB+EICgkYHjnEV5cAAAApSURBVEjHY2AYBaNgFJAOQvEDh1EFowpGFWBRsAo/aBhVMKpgVAGmAgBrTxbnZ9bOpwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wOC0xMFQwOToyNDozMCswMDowMMk6o/kAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDgtMTBUMDk6MjQ6MzArMDA6MDC4ZxtFAAAAAElFTkSuQmCC'
  },
  {
    label: 'Japan',
    value: 'jpa',
    nativeName: 'Japan',
    key: 3,
    flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAABTCAMAAACF+PhRAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABOFBMVEX////78fPxy9TrssDop7fkmav55+vkmqzTWXbDHES8AC3UWnflm6356Oz+/f3qrrzPSWm9Ay+9BDDPSmrqr73//v7HKlDHK1Doqbj01t3NQGLNQmP12N/mobK/CjW+CDTikKT++vvVX3vWYn7++/z89ffQS2vORGX9+frUW3jVXnrikaTjlKfyzte+BzPz0NjLOFvKNVnkmKrEH0fEHUXlnK3mnq/JM1fKN1r01dz0197egpjfhZu+CTT22+Hrsb/rs8Dhi5/hjaHeg5nNQWPORWbfhpvKNFjlna7mn7DEHkbLOVzz0dnjk6bkl6nVYX3+/P3RUG/QTGzQTWz99vjWZH/XZ4K/CzbOQ2T12uHpq7rILFHILlPprbu9BTH56e3UXHnUXXr56u788/XyzNXrtMHoqLfyzdZu4LVCAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+YEEw00EWKnTNgAAAGiSURBVGje7ZmHTgJBEIaPJjIiIogFUSwURQUUxS4qFsSOvRcE3/8NjDGSaIDbSWbuEjLfC3zZ3OzMzn+aJgiCIAiCUMNitdkddpvVYri5zdnugl9cHe5O49SeLm83/MXn7/EY4g7Ye6Eeff0GyAeC0IjBELd8aBgaEx5hdY+OQXPGI3zyqB/0iEXZTu4FfeITTMU+CSokeOxToMY0h3wmqWhPphgaXBpUmaVve3Ogjpu83jMI+zx13S8AhiyxfRFlX6KVLwOOFVL7KtK+RmoPIu1x0ooPI+3rlLMuBFg2CO05tH3TpEb3g5PQvoW2bxPa82h7vmXOjv/u7papeXPvu7m9TttB2ndJpwz2yu3R7o6mzndtHyVPE7+sCij7gZlv2iL5LudE2Av0u8yhmbuMllLd48JHHGvksaL9hGeFTijJT5myi7NzBXmMLbmJlnTlF5d8sVHkSkd+zZhZfed1N83mqoM7LgzdNh6rdwZkpfcPdd2PT8Zk1IFcyfdP/VyyBYwLyV8Kr8WaOvOWfTf8D0H5o1J1VCufZU0QBEEQBKHGF/28ahI3KDeEAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA0LTE5VDEzOjUyOjE3KzAwOjAwzROo2gAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wNC0xOVQxMzo1MjoxNyswMDowMLxOEGYAAAAASUVORK5CYII='
  }
]

export const USER_STATUS_VALUE = Object.freeze({
  block: 'block',
  active: 'active'
})

export const USER_STATUS_LIST = [
  { label: 'All', value: '' },
  { label: 'Active', value: USER_STATUS_VALUE.active },
  { label: 'Block', value: USER_STATUS_VALUE.block }
]

export const DEFAULT_USER_STATUS_LIST = { label: 'All', value: '' }

export const SEARCH_IN = [
  {
    value: 'translated',
    label: 'Only translated strings'
  },
  {
    value: 'not_translated',
    label: 'Only untranslated strings'
  },
  {
    value: 'both',
    label: 'Both translated and untranslated strings'
  }
]

export const DEFAULT_GENDER = { label: 'Male', value: 1 }

export const GENDER_LIST = [
  { label: 'Male', value: 1 },
  { label: 'Female', value: 2 }
]

export const DEFAULT_GROUP = {
  id: 0,
  label: 'All',
  value: 0
}

export const SEARCH_SCOPE = {
  value: 'both',
  label: 'Both translated and untranslated strings'
}

export const SPECIAL_LABEL_FILTER = [
  'selectedLanguage',
  'selectedSearchScope',
  'selectedLabelInterfacePage'
]

export const USER_FILTER = Object.freeze({
  name: <IntlMessages id="user.name" />,
  email: <IntlMessages id="user.email" />,
  status: <IntlMessages id="user.status" />
})

export const LOG_MAIL_STATUS_LABEL = Object.freeze({
  pending: <IntlMessages id="log_mail.status_to_send" />,
  done: <IntlMessages id="log_mail.status_sent" />,
  fail: <IntlMessages id="log_mail.status_failed" />
})

export const LOG_MAIL_STATUS_LIST = toArrayOptions(LOG_MAIL_STATUS_LABEL)

export const DATE_LOG_MAIL_FILTER = ['sentFrom', 'sentTo']

export const MAPPING_LANGUAGE = Object.freeze({
  en: 'gb',
  uk: 'gb',
  ja: 'jp',
  hi: 'in',
  zh: 'cn',
  vi: 'vn'
})

export const SELECT_LOG_ROUTINE_FILTER = ['selectedCodeRoutine']

export const DATE_LOG_ROUTINE_FILTER = ['sentFrom', 'sentTo']

export const DEFAULT_VEHICLE_TYPE = {
  label: <IntlMessages id="vehicle_model.vigoz" />,
  value: '1'
}

export const VEHICLE_TYPE_LIST = [
  { label: <IntlMessages id="vehicle_model.vigoz" />, value: '1' },
  { label: <IntlMessages id="vehicle_model.e_bike" />, value: '2' }
]

export const VEHICLE_TYPE_VALUES = Object.freeze({
  1: <IntlMessages id="vehicle_model.vigoz" />,
  2: <IntlMessages id="vehicle_model.e_bike" />
})

export const MAPPING_VEHICLE_MODEL_FILTER = Object.freeze({
  nameVehicleModel: <IntlMessages id="vehicle_model.name" />,
  vehicleType: <IntlMessages id="vehicle_model.type" />,
  vehicleBrand: <IntlMessages id="vehicle_model.brand" />
})

export const MAPPING_VEHICLE_TYPE_FILTER = Object.freeze({
  label: <IntlMessages id="vehicle_types.label" />
})

export const MAPPING_MESSAGE_FILTER = Object.freeze({
  message: <IntlMessages id="messages.string" />,
  keyword: <IntlMessages id="messages.keyword" />,
  selectedModule: <IntlMessages id="messages.module" />,
  selectedLanguage: <IntlMessages id="messages.language" />,
  selectedSearchScope: <IntlMessages id="messages.search_in" />
})

export const PILOT_STATUS_OPTIONS = [
  { value: 'requested', label: <IntlMessages id="status.requested" /> },
  { value: 'approved', label: <IntlMessages id="status.approved" /> },
  { value: 'refused', label: <IntlMessages id="status.refused" /> },
  { value: 'canceled', label: <IntlMessages id="status.canceled" /> }
]

export const PILOT_STATUSES = Object.freeze({
  requested: <IntlMessages id="status.requested" />,
  approved: <IntlMessages id="status.approved" />,
  refused: <IntlMessages id="status.refused" />,
  canceled: <IntlMessages id="status.canceled" />
})

export const MAPPING_KEY_USAGE_SYSTEM_LOG_FILTER = Object.freeze({
  type: <IntlMessages id="key_usage_system_log.type" />,
  languageId: <IntlMessages id="key_usage_system_log.language" />,
  moduleId: <IntlMessages id="key_usage_system_log.module" />,
  searchIn: <IntlMessages id="key_usage_system_log.search_in" />,
  keyword: <IntlMessages id="key_usage_system_log.keyword" />,
  originalName: <IntlMessages id="key_usage_system_log.string" />
})

export const MAPPING_USAGE_SYSTEM_LOG_FILTER = Object.freeze({
  type: <IntlMessages id="usage_system_log.type" />,
  sender: <IntlMessages id="usage_system_log.sender" />,
  logLabel: <IntlMessages id="usage_system_log.log_label" />
})

export const DEFAULT_MESSAGE_AFTER_CONNECTION_FILTER = Object.freeze({
  portalId: '',
  title: '',
  dtBegin: '',
  dtEnd: ''
})

export const ACTIVITY_TYPE_VALUE = Object.freeze({
  systemLog: 'system_log',
  manualComment: 'manual_comment',
  iotMessage: 'iot_message'
})

export const MODEL_TYPES = Object.freeze({
  company: 'company',
  vehicle: 'vehicle',
  vehicle_brand: 'vehicle_brand',
  electronic_key: 'electronic_key',
  user_app: 'user_app',
  subscription: 'subscription',
  pers: 'pers'
})

export const ACTIVITY_TYPE_LABEL = Object.freeze({
  [ACTIVITY_TYPE_VALUE.manualComment]: <IntlMessages id="activity.manual" />,
  [ACTIVITY_TYPE_VALUE.iotMessage]: <IntlMessages id="activity.iot_message" />,
  [ACTIVITY_TYPE_VALUE.systemLog]: <IntlMessages id="activity.system_log" />
})

export const MEMBER_STATUSES = Object.freeze({
  requested: 1,
  accepted: 2,
  refused: 3,
  canceled: 4
})

export const MEMBER_STATUS_VALUES = Object.freeze({
  1: <IntlMessages id="status.requested" />,
  2: <IntlMessages id="status.accepted" />,
  3: <IntlMessages id="status.refused" />,
  4: <IntlMessages id="status.canceled" />
})

export const CANCEL_MEMBER_SUCCESS_MESSAGE = (
  <SystemMessages id="CANCEL_MEMBER_SUCCESS_MESSAGE" />
)
export const CANCEL_MEMBER_FAILED_MESSAGE = (
  <SystemMessages id="CANCEL_MEMBER_FAILED_MESSAGE" />
)

export const REQUEST_CONFIRM_MESSAGE =
  'Are you sure you want to request {name}?'
export const REFUSE_CONFIRM_MESSAGE = 'Are you sure you want to refuse {name}?'
export const APPROVE_CONFIRM_MESSAGE =
  'Are you sure you want to approve {name}?'
export const DELETE_CONFIRM_MESSAGE = 'Are you sure you want to delete {name}?'
export const CANCEL_CONFIRM_MESSAGE = 'Are you sure you want to cancel {name}?'
export const DELETE_MEMBER_CONFIRM_MESSAGE =
  'Are you sure you want to delete this member ?{name}'

export const REMOVE_CHILDREN_COMPANY_CONFIRM_MESSAGE =
  'This child company will become Individual Company. Do you confirm ?{name}'

export const MAPPING_CHILDREN_COMPANY_FILTER = Object.freeze({
  companyName: <IntlMessages id="companies.name" />,
  zipCode: <IntlMessages id="companies.zip_code" />,
  selectedCountry: <IntlMessages id="companies.country" />
})

export const DEFAULT_PAGE_LIMIT = {
  page: PAGINATION.firstPage,
  limit: PAGINATION.limit
}

export const DEFAULT_SCROLL_LOAD_PAGE_LIMIT = {
  page: PAGINATION.firstPage,
  limit: 36
}

export const DEFAULT_NOTIFICATION_SENT_FILTER = {
  keyPlatformTech: '',
  emailUserDestList: '',
  notificationType: '',
  limit: PAGINATION.unlimited
}

export const DEFAULT_DATE_TIME_FORMAT = {
  selectedLanguage: ''
}

export const DEFAULT_TOPIC_FILTER = {
  topicType: null,
  ...DEFAULT_PAGE_LIMIT
}

export const DEFAULT_DOCUMENTATION_FILTER = {
  name: '',
  topicId: null,
  ...DEFAULT_PAGE_LIMIT
}

export const DEFAULT_LABEL_FILTER = {
  name: '',
  keyword: '',
  selectedModule: null,
  selectedLanguage: null,
  selectedSearchScope: SEARCH_SCOPE,
  selectedLabelInterfacePage: null,
  limit: PAGINATION.limit,
  offset: PAGINATION.offset
}

export const DEFAULT_TEXT_FILTER = {
  selectedLanguage: null,
  selectedSearchScope: SEARCH_SCOPE,
  selectedModule: null,
  keyword: '',
  originalText: '',
  ...DEFAULT_PAGE_LIMIT
}

export const DEFAULT_ROLE_FILTER = {
  name: '',
  groupCode: '',
  sortBy: 'name:ASC'
}

export const DEFAULT_USER_FILTER = {
  name: '',
  email: '',
  status: '',
  sortBy: 'name:ASC'
}

export const DEFAULT_VEHICLE_SUBSCRIPTION_FILTER = {
  companyId: '',
  subscriber: '',
  status: '',
  subscriptionRef: ''
}

export const DEFAULT_CONDITIONAL_FEATURE_FILTER = {
  module: null,
  keyword: '',
  title: '',
  ...DEFAULT_PAGE_LIMIT
}

export const MAPPING_ROLE_FILTER = Object.freeze({
  name: <IntlMessages id="roles.title" />,
  groupCode: <IntlMessages id="roles.type" />
})

export const VEHICLE_ELECTRONIC_KEY_STATUS_VALUES = Object.freeze({
  1: <IntlMessages id="status.new" />,
  2: <IntlMessages id="status.in_progress" />,
  3: <IntlMessages id="status.closed" />
})

export const VEHICLE_ELECTRONIC_KEY_STATUSES = [
  { value: '1', label: <IntlMessages id="status.new" /> },
  { value: '2', label: <IntlMessages id="status.in_progress" /> },
  { value: '3', label: <IntlMessages id="status.closed" /> }
]

export const MAPPING_LOGS = Object.freeze({
  name: <IntlMessages id="app_users.name" />,
  companyName: <IntlMessages id="companies.name" />,
  cityAddress: <IntlMessages id="companies.address" />,
  countryAddressId: <IntlMessages id="companies.country" />,
  serialNumber: <IntlMessages id="vehicles.serial_number" />,
  vehicleType: <IntlMessages id="vehicles.type" />,
  registrationNumber: <IntlMessages id="vehicles.registration_number" />,
  nameVehicle: <IntlMessages id="vehicles.name" />,
  dtOptinProCenter: <IntlMessages id="gdpr.date" />,
  optinProCenter: <IntlMessages id="gdpr.opt_in_service_center" />,
  platformTechKey: <IntlMessages id="gdpr.platform_tech" />,
  referenceSubscription: (
    <IntlMessages id="subscription.reference_subscription" />
  ),
  nuSerialElectronicKeyNumber: (
    <IntlMessages id="electronic_keys.serial_number" />
  ),
  geolocStatus: <IntlMessages id="per_current_data.geoloc_status" />,
  odooUserId: <IntlMessages id="app_users.odoo_id" />,
  country: <IntlMessages id="app_users.country" />,
  dtDelivered: <IntlMessages id="companies.delivered_date" />,
  linkType: <IntlMessages id="companies.link_type" />,
  countryAddress: <IntlMessages id="companies.country" />,
  odooCompanyId: <IntlMessages id="companies.odoo_id" />,
  activationPin: <IntlMessages id="pers.activation_pin" />,
  ownerPin: <IntlMessages id="pers.activation_pin" />,
  nuSerialPersNumber: <IntlMessages id="pers.serial_number" />,
  odooPersId: <IntlMessages id="pers.odoo_id" />,
  modelPERS: <IntlMessages id="pers.pers_model" />,
  odooVehicleId: <IntlMessages id="vehicles.odoo_vehicle_id" />,
  isCurrent: <IntlMessages id="vehicles.is_current" />,
  status: <IntlMessages id="vehicles.status" />,
  periodStartDate: <IntlMessages id="vehicles.period_start_date" />,
  periodEndDate: <IntlMessages id="vehicles.period_end_date" />
})

export const MODULE_TYPES = {
  SHOWCASE_WEB: 'showcaseweb',
  MOBILE_APP: 'mobileapp',
  CIXI_CENTER: 'cixicenter',
  SERVICE_CENTER: 'procenter',
  PERS: 'pers'
}

export const MODULES = {
  [MODULE_TYPES.SHOWCASE_WEB]: <IntlMessages id="module.showcase_web" />,
  [MODULE_TYPES.MOBILE_APP]: <IntlMessages id="module.pilot_mobile_app" />,
  [MODULE_TYPES.CIXI_CENTER]: <IntlMessages id="module.cixi_center" />,
  [MODULE_TYPES.PERS]: <IntlMessages id="module.pers" />,
  [MODULE_TYPES.SERVICE_CENTER]: <IntlMessages id="module.service_center" />
}

export const MAP_MODULE_TO_FILTER = {
  [MODULE_TYPES.CIXI_CENTER]: 'filter',
  [MODULE_TYPES.SHOWCASE_WEB]: 'scwFilter',
  [MODULE_TYPES.MOBILE_APP]: 'mobileFilter'
}

export const TYPE_KEY_USAGE_SYSTEM_LOG_NUM = {
  info: 1,
  success: 2,
  warning: 3,
  error: 4
}

export const TYPE_KEY_USAGE_SYSTEM_LOG_LABEL = {
  [TYPE_KEY_USAGE_SYSTEM_LOG_NUM.info]: (
    <IntlMessages id="key_usage_system_log.info" />
  ),
  [TYPE_KEY_USAGE_SYSTEM_LOG_NUM.success]: (
    <IntlMessages id="key_usage_system_log.success" />
  ),
  [TYPE_KEY_USAGE_SYSTEM_LOG_NUM.warning]: (
    <IntlMessages id="key_usage_system_log.warning" />
  ),
  [TYPE_KEY_USAGE_SYSTEM_LOG_NUM.error]: (
    <IntlMessages id="key_usage_system_log.error" />
  )
}

export const TYPE_KEY_USAGE_SYSTEM_LOG_LIST = Object.keys(
  TYPE_KEY_USAGE_SYSTEM_LOG_LABEL
).map((value) => ({ label: TYPE_KEY_USAGE_SYSTEM_LOG_LABEL[value], value }))

export const TOPIC_TYPES = {
  0: <IntlMessages id="topic.faqTopic" />,
  1: <IntlMessages id="topic.documentationTopic" />
}

export const SUBSCRIPTION_SUBSCRIBER_TYPE = [
  {
    value: 'company',
    label: <IntlMessages id="subscription.subscriber_type_company" />
  },
  {
    value: 'individual',
    label: <IntlMessages id="subscription.subscriber_type_individual" />
  }
]

export const SUBSCRIPTION_STATUSES = [
  {
    label: <IntlMessages id="subscription.requested_by_customer" />,
    value: 'requested_by_customer'
  },
  {
    label: <IntlMessages id="subscription.proposed_by_cixi" />,
    value: 'proposed_by_cixi'
  },
  {
    label: <IntlMessages id="subscription.accepted_by_customer" />,
    value: 'accepted_by_customer'
  },
  {
    label: <IntlMessages id="subscription.accepted_by_cixi" />,
    value: 'accepted_by_cixi'
  },
  { label: <IntlMessages id="subscription.delivered" />, value: 'delivered' },
  {
    label: <IntlMessages id="subscription.request_refused_by_cixi" />,
    value: 'request_refused_by_cixi'
  },
  {
    label: <IntlMessages id="subscription.request_canceled_by_customer" />,
    value: 'request_canceled_by_customer'
  },
  {
    label: <IntlMessages id="subscription.proposal_refused_by_customer" />,
    value: 'proposal_refused_by_customer'
  },
  {
    label: <IntlMessages id="subscription.proposal_canceled_by_cixi" />,
    value: 'proposal_canceled_by_cixi'
  },
  { label: <IntlMessages id="subscription.in_closure" />, value: 'in_closure' },
  { label: <IntlMessages id="subscription.closed" />, value: 'closed' },
  {
    label: <IntlMessages id="subscription.canceled_by_cixi" />,
    value: 'canceled_by_cixi'
  }
]

export const SUBSCRIPTION_STATUS_OBJECT = SUBSCRIPTION_STATUSES.reduce(
  (acc, t) => ({ ...acc, [t.value]: t }),
  {}
)

export const SUBSCRIPTION_VEHICLE_STATUSES = [
  {
    label: <IntlMessages id="subscription.coming" />,
    value: 'coming'
  },
  {
    label: <IntlMessages id="subscription.delivery_in_progress" />,
    value: 'delivery_in_progress'
  },
  {
    label: <IntlMessages id="subscription.in_progress" />,
    value: 'in_progress'
  },
  {
    label: <IntlMessages id="subscription.returned" />,
    value: 'returned'
  }
]

export const SUBSCRIPTION_VEHICLE_STATUS_VALUES = {
  coming: <IntlMessages id="subscription.coming" />,
  delivery_in_progress: <IntlMessages id="subscription.delivery_in_progress" />,
  in_progress: <IntlMessages id="subscription.in_progress" />,
  returned: <IntlMessages id="subscription.returned" />
}

export const SUBSCRIPTION_MAPPING_FILTER = Object.freeze({
  vehicleName: <IntlMessages id="subscription.vehicle_name" />,
  vehicleRegistrationNumber: (
    <IntlMessages id="subscription.vehicle_registration_number" />
  ),
  status: <IntlMessages id="subscription.status" />,
  vehicleType: <IntlMessages id="subscription.vehicle_type" />,
  referenceSubscription: <IntlMessages id="subscription.subscription" />,
  subscriber: <IntlMessages id="subscription.subscriber" />,
  company: <IntlMessages id="subscription.company" />
})

export const DOCUMENT_CONTENT_TYPES = Object.freeze({
  RICH_TEXT: 1,
  PDF: 2,
  EXTERNAL_URL: 3
})

export const DOCUMENT_CONTENT_TYPE_VALUES = Object.freeze({
  [DOCUMENT_CONTENT_TYPES.RICH_TEXT]: <IntlMessages id="type.rich_text" />,
  [DOCUMENT_CONTENT_TYPES.PDF]: <IntlMessages id="type.pdf" />,
  [DOCUMENT_CONTENT_TYPES.EXTERNAL_URL]: <IntlMessages id="type.extenal_url" />
})

export const DEFAULT_SUBSCRIPTION_TYPE = 'company'

export const DELETE_TRANSLATION_CONFIRM_MESSAGE =
  'Are you sure you want to delete Translation value for {name} ?'

export const DEFAULT_FAQ_FILTER = {
  name: '',
  topic: '',
  ...DEFAULT_PAGE_LIMIT
}

export const STORY_STATUS_VALUE = Object.freeze({
  PUBLISH: 'published',
  UNPUBLISH: 'un_published'
})

export const STORY_STATUS_LABEL = Object.freeze({
  [STORY_STATUS_VALUE.PUBLISH]: <IntlMessages id="story.status_published" />,
  [STORY_STATUS_VALUE.UNPUBLISH]: (
    <IntlMessages id="story.status_un_published" />
  )
})

export const STORY_STATUS_LIST = toArrayOptions(STORY_STATUS_LABEL)

export const CAROUSEL_TAG_STORY_VALUE = Object.freeze({
  client: 'CLIENT',
  vision: 'VISION'
})

export const CAROUSEL_TAG_STORY_LABEL = Object.freeze({
  [CAROUSEL_TAG_STORY_VALUE.client]: (
    <IntlMessages id="story.carousel_tag_client" />
  ),
  [CAROUSEL_TAG_STORY_VALUE.vision]: (
    <IntlMessages id="story.carousel_tag_vision" />
  )
})

export const CAROUSEL_TAG_STORY_LIST = toArrayOptions(CAROUSEL_TAG_STORY_LABEL)

export const FAQ_TOPICS = Object.freeze({
  1: <IntlMessages id="faq.pers_technology" />,
  2: <IntlMessages id="faq.vigoz" />,
  3: <IntlMessages id="faq.eBike" />
})

export const FAQ_STATUS = Object.freeze({
  published: 'published',
  unPublished: 'un_published'
})

export const MAPPING_MAIN_PICTURE_FILE_TYPES = Object.freeze({
  ANIMATED_PICTURE: ['gif'],
  STATIC_PICTURE: ['png', 'jpg', 'jpeg', 'webp'],
  VIDEO: ['mp4', 'avi', 'wmv']
})

export const PUBLISH_STORY_CONFIRM_MESSAGE =
  'Are you sure you want to publish the story: {name}?'

export const PUBLISH_STORY_UN_CONFIRM_MESSAGE =
  'Are you sure you want to unpublish the story: {name}?'

export const PUBLISH_STORY_SUCCESS = (
  <SystemMessages id="PUBLISH_STORY_SUCCESS" />
)
export const PUBLISH_STORY_FAILED = <SystemMessages id="PUBLISH_STORY_FAILED" />

export const UN_PUBLISH_STORY_SUCCESS = (
  <SystemMessages id="UN_PUBLISH_STORY_SUCCESS" />
)
export const UN_PUBLISH_STORY_FAILED = (
  <SystemMessages id="UN_PUBLISH_STORY_FAILED" />
)

export const SCW_SECTION_PAGE_VALUES = Object.freeze({
  1: 'HOMEPAGE',
  2: 'ACTIVE_VEHICLE',
  3: 'ACTIVE_VEHICLE_TECHNOLOGY',
  4: 'ABOUT_US',
  5: 'ABOUT_US_STORIES',
  6: 'VIBES_STORIES_DETAIL',
  7: 'CONTACT_US',
  8: 'STORIES',
  9: 'STORY_DETAIL',
  10: 'PRIVACY_POLICY',
  11: 'HUBPAGE',
  12: 'PERS_FOR_PRO',
  13: 'VIRTUAL_PATENT_MARKING'
})

export const MOBILE_PAGE_VALUES = Object.freeze({
  11: 'LANDING_VEHICLE',
  12: 'DETAILED_VEHICLE',
  13: 'SHARING',
  14: 'KEYCHAIN',
  15: 'CHECKIN',
  16: 'CHECKOUT',
  17: 'PROFILE',
  18: 'LOGIN',
  19: 'RECOVERY_PASSWORD'
})

export const ALL_PAGE_VALUES = Object.freeze({
  ...SCW_SECTION_PAGE_VALUES,
  ...MOBILE_PAGE_VALUES
})

export const SECTION_PAGE_LIST = Object.keys(SCW_SECTION_PAGE_VALUES).map(
  (value) => ({
    label: SCW_SECTION_PAGE_VALUES[value],
    value
  })
)

export const MOBILE_PAGE_LIST = Object.keys(MOBILE_PAGE_VALUES).map(
  (value) => ({ label: MOBILE_PAGE_VALUES[value], value })
)

export const GROUPS_PAGE_BY_MODULE = {
  [MODULE_TYPES.SHOWCASE_WEB]: SECTION_PAGE_LIST,
  [MODULE_TYPES.MOBILE_APP]: MOBILE_PAGE_LIST
}

export const CONTACT_LOG_TYPES = Object.freeze({
  notify_me: 'notify_me',
  request_brochure: 'request_brochure',
  contact_us: 'contact_us',
  vigoz_club: 'vigoz_club'
})

export const CONTACT_LOG_LIST = [
  {
    label: <IntlMessages id="brochure_request_log.notify_me" />,
    value: 'notify_me'
  },
  {
    label: <IntlMessages id="brochure_request_log.request_brochure" />,
    value: 'request_brochure'
  },
  {
    label: <IntlMessages id="brochure_request_log.contact_us" />,
    value: 'contact_us'
  },
  {
    label: <IntlMessages id="brochure_request_log.vigoz_club" />,
    value: 'vigoz_club'
  }
]

export const CONTACT_LOG_TYPE_VALUES = Object.freeze({
  notify_me: <IntlMessages id="brochure_request_log.notify_me" />,
  request_brochure: <IntlMessages id="brochure_request_log.request_brochure" />,
  contact_us: <IntlMessages id="brochure_request_log.contact_us" />,
  vigoz_club: <IntlMessages id="brochure_request_log.vigoz_club" />
})

export const NOTIFY_ME_REQUEST_TYPE_VALUES = Object.freeze({
  private_individual: (
    <IntlMessages id="brochure_request_log.private_individual" />
  ),
  company: <IntlMessages id="brochure_request_log.company" />
})

// USED IN BRAND MESSAGES
export const DEVICE_TYPES = Object.freeze({
  1: <IntlMessages id="brand_message.smart_phone" />,
  2: <IntlMessages id="brand_message.tablet" />,
  3: <IntlMessages id="brand_message.desktop" />
})

export const SUBSCRIPTION_TYPES = Object.freeze({
  COMPANY: 'company',
  INDIVIDUAL: 'individual'
})

export const DEFAULT_KEY_USAGE_SYSTEM_LOG_FILTER = {
  originalName: '',
  keyword: '',
  type: '',
  moduleId: '',
  languageId: '',
  searchIn: SEARCH_SCOPE.value,
  limit: PAGINATION.limit
}

export const DEFAULT_USAGE_SYSTEM_LOG_FILTER = {
  logLabel: '',
  sender: '',
  type: '',
  startDate: '',
  endDate: '',
  persId: '',
  limit: PAGINATION.limit
}

export const CURRENCY_FORMAT_DISPLAY = {
  afterAmount: 1,
  beforeAmount: 2
}

export const DROPDOWN_STYLES = {
  // For the select it self, not the options of the select
  control: (styles, { isDisabled }) => {
    return {
      ...styles,
      cursor: isDisabled ? 'not-allowed' : 'default'
    }
  },
  // For the options
  option: (styles, { isDisabled }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? '#E0E0E0 !important' : ''
    }
  }
}

export const SUPER_ADMIN = 'SuperAdmin'

export const STATUS_PER_ALERT_LABEL = {
  1: <IntlMessages id="per_alert.status_received" />
}

export const TYPE_MAIL_TEMPLATES = {
  BO_USER: 1,
  PORTAL_USER: 2,
  COMPANY_MEMBER: 3
}

export const TYPE_MAIL_VALUES = {
  1: 'BO User',
  2: 'Portal User',
  3: 'Company Member'
}

export const TYPE_MAIL_LIST = [
  { label: TYPE_MAIL_VALUES[1], value: 1 },
  { label: TYPE_MAIL_VALUES[2], value: 2 },
  { label: TYPE_MAIL_VALUES[3], value: 3 }
]

export const DEFAULT_COMPANY_MAIL_TEMPLATES_FILTER = {
  selectedModule: '',
  keyword: '',
  name: '',
  typeMailTemplate: 3
}

export const MAPPING_COMPANY_MAIL_TEMPLATE_FILTER = Object.freeze({
  name: <IntlMessages id="company_mail_templates.name" />,
  keyword: <IntlMessages id="company_mail_templates.keyword" />,
  selectedModule: <IntlMessages id="company_mail_templates.module" />
})
export const COMPANY_ADMIN_STATUS = {
  REQUESTED: 1,
  ACCEPTED: 2,
  REFUSED: 3,
  CANCELED: 4
}

export const COMPANY_ADMIN_STATUS_VALUES = {
  1: <IntlMessages id="status.requested" />,
  2: <IntlMessages id="status.approved" />,
  3: <IntlMessages id="status.refused" />,
  4: <IntlMessages id="status.canceled" />
}

export const COMPANY_ADMIN_STATUS_LIST = [
  { label: COMPANY_ADMIN_STATUS_VALUES[1], value: 1 },
  { label: COMPANY_ADMIN_STATUS_VALUES[2], value: 2 },
  { label: COMPANY_ADMIN_STATUS_VALUES[3], value: 3 }
]

export const MAIN_ADMIN_ROLE = 'main_admin_role'

export const COMPANY_ROLE_CONFIGURATION_VALUES = {
  main_admin_role: <IntlMessages id="main_admin_role" />
}

export const DEFAULT_SERVICE_CENTER_ADMIN_FILTER = {
  name: '',
  email: '',
  company: '',
  status: '',
  ...DEFAULT_PAGE_LIMIT
}

export const MAPPING_SERVICE_CENTER_ADMIN_FILTER = Object.freeze({
  name: 'Name',
  email: 'Email',
  company: 'Company',
  status: 'Status'
})

export const LINK_TYPE_LIST = [
  { label: <IntlMessages id="vehicle_brands.owner" />, value: 1 },
  { label: <IntlMessages id="vehicle_brands.contractor" />, value: 8 }
]

export const LINK_TYPE_VALUES = Object.freeze({
  1: <IntlMessages id="vehicle_brands.owner" />,
  8: <IntlMessages id="vehicle_brands.contractor" />
})

export const LINK_TYPES = [
  { value: 1, label: <IntlMessages id="vehicle_brands.owner" /> },
  { value: 8, label: <IntlMessages id="vehicle_brands.contractor" /> }
]

export const COMPANY_LINK_TYPE_LIST = [
  { label: <IntlMessages id="vehicles.manufacturer" />, value: 1 },
  { label: <IntlMessages id="vehicles.no_manufacturer" />, value: 0 }
]

export const COMPANY_LINK_TYPE_VALUES = Object.freeze({
  1: <IntlMessages id="vehicles.manufacturer" />,
  0: <IntlMessages id="vehicles.no_manufacturer" />
})

export const COMPANY_FILTER_TYPE = Object.freeze({
  EQUAL: 1,
  NOT_EQUAL: 2
})

export const LIST_AVATAR_CODES = [
  'default_avatar_company',
  'default_avatar_vehicle',
  'default_avatar_user_BO',
  'default_avatar_electronic_key',
  'default_avatar_bike',
  'default_avatar_user_app',
  'default_image_company_selection'
]

export const DATA_MAPPING_INIT_VALUES = {
  keyFeature: '',
  keyword: '',
  sourceValue: '',
  destinationValue: '',
  comment: '',
  emptyDestinationValue: false
}

export const KEY_FEATURE = Object.freeze({
  ODOO_TO_SERVER: 'OdooToServer',
  SERVER_TO_ODOO: 'ServerToOdoo'
})

export const KEY_FEATURE_LIST = [
  { label: KEY_FEATURE.ODOO_TO_SERVER, value: KEY_FEATURE.ODOO_TO_SERVER },
  { label: KEY_FEATURE.SERVER_TO_ODOO, value: KEY_FEATURE.SERVER_TO_ODOO }
]

export const DEFAULT_PLATFORM_TECH_KEY = {
  cixiCenter: 'CIXI_CENTER',
  pilotAppIOS: 'PILOT_APP_IOS',
  pilotAppAndroid: 'PILOT_APP_ANDROID',
  serviceCenterWeb: 'SERVICE_CENTER_WEB',
  fleetManagerWeb: 'FLEET_MANAGER_WEB'
}

export const NOTIFICATION_TYPE_VALUES = Object.freeze({
  1: <IntlMessages id="notifications.push_type" />,
  2: <IntlMessages id="notifications.in_app_type" />
})

export const NOTIFICATION_IN_APP_STATUS_VALUES = Object.freeze({
  1: <IntlMessages id="notifications.prepared_status" />,
  2: <IntlMessages id="notifications.impression_status" />,
  3: <IntlMessages id="notifications.opened_status" />
})

export const NOTIFICATION_PUSH_STATUS_VALUES = Object.freeze({
  1: <IntlMessages id="notifications.prepared_status" />,
  2: <IntlMessages id="notifications.sent_status" />,
  3: <IntlMessages id="notifications.impression_status" />,
  4: <IntlMessages id="notifications.opened_status" />,
  5: <IntlMessages id="notifications.on_error_status" />
})

export const GROUP_ALERT_FIELDS_VALUES = Object.freeze({
  id: '',
  groupAlertId: '',
  numOrder: ''
})

export const WS_URL = 'ws://127.0.0.1:8888'

export const GLOBAL_USER_TYPE_VALUES = Object.freeze({
  rider: 'Rider',
  serviceCenterAdmin: 'Pro Center Admin',
  serviceCenterMember: 'Pro Center Member'
})

export const GLOBAL_USER_TYPE_LABEL = {
  [GLOBAL_USER_TYPE_VALUES.rider]: <IntlMessages id="app_users.type_rider" />,
  [GLOBAL_USER_TYPE_VALUES.serviceCenterAdmin]: (
    <IntlMessages id="app_users.type_service_center_admin" />
  ),
  [GLOBAL_USER_TYPE_VALUES.serviceCenterMember]: (
    <IntlMessages id="app_users.type_service_center_member" />
  )
}

export const GLOBAL_USER_TYPE_LIST = toArrayOptions(GLOBAL_USER_TYPE_LABEL)

export const MINE_TYPES = Object.freeze({
  JSON: 'application/json'
})

export const TYPE_COMN_LIST = [
  { label: 'PersToServer', value: 1 },
  { label: 'ServerToPers', value: 2 }
]
export const TYPE_COMN_VALUES = Object.freeze({
  1: 'PersToServer',
  2: 'ServerToPers'
})

export const STATUS_CONFIGURATION_FILE_VALUES = Object.freeze({
  1: <IntlMessages id="action_requested" />,
  2: <IntlMessages id="action_executed" />,
  3: <IntlMessages id="action_closed" />,
  4: <IntlMessages id="action_expired" />,
  5: <IntlMessages id="on_error" />
})

export const CARD_MARKET_PLACE_STATUS_VALUES = Object.freeze({
  0: <IntlMessages id="story.status_un_published" />,
  1: <IntlMessages id="story.status_published" />
})

export const CARD_MARKET_PLACE_STATUS = Object.freeze({
  UNPUBLISHED: 0,
  PUBLISHED: 1
})

export const PUBLISH_CARD_MARKET_PLACE_STATUS_CONFIRM_MESSAGE =
  'Are you sure you want to publish the Card Marketplace: {name}?'

export const UNPUBLISH_CARD_MARKET_PLACE_STATUS_CONFIRM_MESSAGE =
  'Are you sure you want to unpublish the Card Marketplace: {name}?'

export const PUBLISH_CARD_MARKET_PLACE_SUCCESS = (
  <SystemMessages id="PUBLISH_CARD_MARKET_PLACE_SUCCESS" />
)
export const PUBLISH_CARD_MARKET_PLACE_FAILED = (
  <SystemMessages id="PUBLISH_CARD_MARKET_PLACE_FAILED" />
)

export const UN_PUBLISH_CARD_MARKET_PLACE_SUCCESS = (
  <SystemMessages id="UN_PUBLISH_CARD_MARKET_PLACE_SUCCESS" />
)
export const UN_PUBLISH_CARD_MARKET_PLACE_FAILED = (
  <SystemMessages id="PUBLISH_CARD_MARKET_PLACE_FAILED" />
)

export const CARD_MARKET_PLACE_STATUS_LIST = [
  { label: <IntlMessages id="story.status_un_published" />, value: 0 },
  { label: <IntlMessages id="story.status_published" />, value: 1 }
]
